// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* UNDP Brand */
  --undp-primary: #0468B1;
  --undp-primary-hover: #035B96;
  --undp-primary-light: #E8F4FD;
  --undp-accent: #00A4D4;

  /* Semantic */
  --color-success: #25903F;
  --color-success-light: #E6F4EA;
  --color-warning: #FDAD15;
  --color-warning-light: #FFF8E1;
  --color-error: #D12800;
  --color-error-light: #FDECEC;

  /* Neutrals */
  --color-text: #1A1A1A;
  --color-text-secondary: #5A5A5A;
  --color-text-tertiary: #8A8A8A;
  --color-border: #D4D6D8;
  --color-border-light: #E8E8E8;
  --color-surface: #FFFFFF;
  --color-background: #F7F7F8;
  --color-background-hover: #F0F0F1;

  /* Spacing */
  --space-xs: 4px;
  --space-sm: 8px;
  --space-md: 16px;
  --space-lg: 24px;
  --space-xl: 32px;
  --space-2xl: 48px;

  /* Radii */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 4px 16px rgba(0, 0, 0, 0.1);

  /* Typography */
  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-mono: 'JetBrains Mono', 'Fira Code', Consolas, monospace;

  /* Layout */
  --sidebar-width: 260px;
  --sidebar-collapsed-width: 64px;
  --content-max-width: 1280px;
}
`, "",{"version":3,"sources":["webpack://./src/theme/tokens.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;;EAEtB,aAAa;EACb,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;;EAE5B,aAAa;EACb,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,iCAAiC;;EAEjC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;;EAE1C,eAAe;EACf,iFAAiF;EACjF,+DAA+D;;EAE/D,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;AAC7B","sourcesContent":[":root {\r\n  /* UNDP Brand */\r\n  --undp-primary: #0468B1;\r\n  --undp-primary-hover: #035B96;\r\n  --undp-primary-light: #E8F4FD;\r\n  --undp-accent: #00A4D4;\r\n\r\n  /* Semantic */\r\n  --color-success: #25903F;\r\n  --color-success-light: #E6F4EA;\r\n  --color-warning: #FDAD15;\r\n  --color-warning-light: #FFF8E1;\r\n  --color-error: #D12800;\r\n  --color-error-light: #FDECEC;\r\n\r\n  /* Neutrals */\r\n  --color-text: #1A1A1A;\r\n  --color-text-secondary: #5A5A5A;\r\n  --color-text-tertiary: #8A8A8A;\r\n  --color-border: #D4D6D8;\r\n  --color-border-light: #E8E8E8;\r\n  --color-surface: #FFFFFF;\r\n  --color-background: #F7F7F8;\r\n  --color-background-hover: #F0F0F1;\r\n\r\n  /* Spacing */\r\n  --space-xs: 4px;\r\n  --space-sm: 8px;\r\n  --space-md: 16px;\r\n  --space-lg: 24px;\r\n  --space-xl: 32px;\r\n  --space-2xl: 48px;\r\n\r\n  /* Radii */\r\n  --radius-sm: 4px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 12px;\r\n\r\n  /* Shadows */\r\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n  --shadow-md: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  --shadow-lg: 0 4px 16px rgba(0, 0, 0, 0.1);\r\n\r\n  /* Typography */\r\n  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n  --font-mono: 'JetBrains Mono', 'Fira Code', Consolas, monospace;\r\n\r\n  /* Layout */\r\n  --sidebar-width: 260px;\r\n  --sidebar-collapsed-width: 64px;\r\n  --content-max-width: 1280px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
